import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { TrackConversionOptions } from '../../entities/tracking-options';
import type {
  ConversionManagerRepository,
  TrackConversionResult,
} from '../../repositories';

export type TrackConversionUseCase = (
  options: TrackConversionOptions,
) => Promise<TrackConversionResult>;

export const trackConversionFactory =
  (
    provider: Pick<ConversionManagerRepository, 'trackConversion'>,
  ): TrackConversionUseCase =>
  async (options) => {
    const parsedOptions = TrackConversionOptions.safeParse(options);

    if (!parsedOptions.success) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTrackConversion',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }
    return provider.trackConversion(options);
  };
